import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import StructuredData from './StructuredData';

const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://consultiumgroup.co.za').replace(/\/$/, '');

/**
 * Breadcrumbs — visual trail + BreadcrumbList JSON-LD schema.
 *
 * items: [{ label: 'Home', to: '/' }, { label: 'Services', to: '/#popular' }, { label: 'Company Registration' }]
 * Last item MUST omit `to` (it's the current page).
 */
const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.label,
      ...(item.to ? { item: `${SITE_URL}${item.to}` } : {}),
    })),
  };

  return (
    <>
      <StructuredData data={schema} />
      <nav
        aria-label="Breadcrumb"
        className="text-sm text-gray-600 mb-6"
        data-testid="breadcrumbs"
      >
        <ol className="flex items-center flex-wrap gap-1">
          {items.map((item, i) => (
            <li key={item.label} className="flex items-center gap-1">
              {i === 0 && <Home className="h-3.5 w-3.5 mr-1 text-emerald-600" />}
              {item.to && i < items.length - 1 ? (
                <Link to={item.to} className="hover:text-emerald-600 hover:underline">
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-900 font-medium" aria-current="page">
                  {item.label}
                </span>
              )}
              {i < items.length - 1 && (
                <ChevronRight className="h-3.5 w-3.5 text-gray-400" />
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
